
/**
 * @Description //TODO 全局变量
 * @author Zhangbin
 * @date 2021/4/30 16:24
 * @Ver 1.3.1
 * @extends Vue
 */

/* permission 变量声明 */
import constants from "vant/lib/sku/constants";

/*
//const BASE_HOST = '127.0.0.1';
const BASE_HOST = '192.168.2.49';// 139.9.191.57 192.168.2.229
const PAGE_PATH = "https://127.0.0.1:8092";
const BASE_PATH = "https://"+ BASE_HOST +":1880";						// 后台访问
const WS_POSITION_PATH = "ws://"+ BASE_HOST +":1882/out";				// ws连接

//const OAM_HOST = '127.0.0.1';
const OAM_HOST = '192.168.2.49';// 139.9.191.57 192.168.2.229
const WS_OAM_PATH = "ws://" + OAM_HOST + ":1882/out";					// oam-ws接口
const OAM_PATH = "https://"+ OAM_HOST +":1880";						// oam接口
const OAM_VIDEO = "https://"+ OAM_HOST +":8000";						// oam-视频接口
*/

const BASE_HOST = 'iotm.bygps.net';// base host 192.168.5.6  192.168.6.10，192.168.22.150,124.31.242.69
//const PAGE_PATH = "https://127.0.0.1:8092";								// 页面访问
// const PAGE_PATH = "https://iot.jinkuncloud.com";						// 页面访问
const PAGE_PATH = "https://iotm.bygps.net";						// 页面访问
const BASE_PATH = "https://"+ BASE_HOST;								// 后台访问
const WS_POSITION_PATH = "ws://"+ BASE_HOST +"/ws/position/out";	// ws连接
//const WS_POSITION_PATH = "ws://iot.jinkuncloud.com:1882/out";	// ws连接
//const WS_POSITION_PATH = "ws://139.9.191.57:1882/out";	// ws连接

// const OAM_HOST = 'iotm.jinkuncloud.com';// oam-host
const OAM_HOST = 'iotm.bygps.net';// oam-host
const WS_OAM_PATH = "ws://"+ OAM_HOST +"/ws/position/out";		// oam-ws接口
//const WS_OAM_PATH = "ws://iot.jinkuncloud.com:1882/out";		// oam-ws接口
//const WS_OAM_PATH = "ws://139.9.191.57:1882/out";		// oam-ws接口
const OAM_PATH = "https://"+ OAM_HOST;									// oam接口
const OAM_VIDEO = "https://"+ OAM_HOST +":8000";							// oam-视频接口


const BASE_PATH_IDCARD = "http://127.0.0.1:24010";						// 后台访问 身份证读卡
const OPEN_NFC = true													// 是否开启NFC功能
const OPEN_ID_CARD = true;												// 是否开启身份证读卡器
const OPEN_VIDEO = true;												// 是否开启视频播放器
const VIDEO_PLAYER_MODE = 2;											// 播放器类型 0、无播放器 1、VLCPlayer 2、WebrtcPlayer


/* secret 变量声明  */

export default {
    BASE_PATH,
    PAGE_PATH,
    WS_POSITION_PATH,

    WS_OAM_PATH,
    OAM_PATH,
    OAM_VIDEO,

    BASE_PATH_IDCARD,
    OPEN_NFC,
    OPEN_ID_CARD,
    OPEN_VIDEO,
    VIDEO_PLAYER_MODE,

}



// WEBPACK FOOTER //
// ./src/global/global-variable.js